import React from 'react'
import './CTA.css';
const CTA = () => {
  return <div className="section-container">
    <div className="cta-container section-margin">
      <div className="cta-text">
        <p>Request Early Access To Get Started</p>
        <h3>Register Today & start exploring the endless possibilities.</h3>
      </div>
      <div className="cta-button">
        <button type='button'>Get Started</button>
      </div>
    </div>
  </div>
}

export default CTA